export default __webpack_public_path__ + "8d9321f821ad631440bfd4904b461e24.png";